import React from "react";
import "./entitydashboard.scss";
import { Link, useParams } from "react-router-dom";
import AdminOnly from "../../AdminOnly";

import { FEATURE_FLAGS, useFeatureFlag } from "~/config/ff";
import PropTypes from "prop-types";

const QuickActions = ({ hasEntityPlusAccess, hasPayrollAccess }) => {
  const { id } = useParams();
  const { value: isEntityCalendarEnabled } = useFeatureFlag(
    FEATURE_FLAGS.ENTITY_CALENDAR,
    false,
  );
  const { value: isDocumentStorageFeatureEnabled } = useFeatureFlag(
    FEATURE_FLAGS.DOCUMENT_STORAGE,
    false,
  );

  const { value: isUpdateActiveServiceFeatureEnabled } = useFeatureFlag(
    FEATURE_FLAGS.UPDATE_ACTIVE_SERVICES,
    false,
  );
  const { value: isEmployeeFeatureEnabled } = useFeatureFlag(
    FEATURE_FLAGS.EMPLOYEE_REGISTRY,
    false,
  );
  return (
    <div className="quick-actions-container">
      <div className="heading-container">
        <h4 className="heading">Quick Actions</h4>
        <p className="desc">What information are you looking for?</p>
      </div>
      <div className="cards-container">
        <div className="action-card">
          <Link className="quick-actions-link" to={`/entity/${id}/info`}>
            <div className="icon-container">
              <span className="pi pi-building"></span>
            </div>
            <p className="card-name">Core Entity Data</p>
          </Link>
        </div>
        {isEmployeeFeatureEnabled && hasPayrollAccess && (
          <div className="action-card">
            <Link className="quick-actions-link" to={`/entity/${id}/employee`}>
              <div className="icon-container">
                <span className="pi pi-users"></span>
              </div>
              <p className="card-name">Employee Registry</p>
            </Link>
          </div>
        )}
        <div className="action-card">
          <Link className="quick-actions-link" to={`/entity/${id}/directors`}>
            <div className="icon-container">
              <span className="pi pi-chart-pie"></span>
            </div>
            <p className="card-name">Directors & Shareholders</p>
          </Link>
        </div>
        {isEntityCalendarEnabled && (
          <div className="action-card">
            <Link className="quick-actions-link" to={`/entity/${id}/calendar`}>
              <div className="icon-container">
                <span className="pi pi-calendar"></span>
              </div>
              <p className="card-name">Entity Calendar</p>
            </Link>
          </div>
        )}
        <div className="action-card">
          <Link
            className="quick-actions-link"
            to={`/entity/${id}/key-personnel`}
          >
            <div className="icon-container">
              <span className="pi pi-users "></span>
            </div>
            <p className="card-name">Key Personnel</p>
          </Link>
        </div>
        {isDocumentStorageFeatureEnabled && (
          <div className="action-card">
            <Link className="quick-actions-link" to={`/files/entity/${id}`}>
              <div className="icon-container">
                <span className="pi pi-folder "></span>
              </div>
              <p className="card-name">Files & Documents</p>
            </Link>
          </div>
        )}
        {hasEntityPlusAccess && (
          <>
            <div className="action-card">
              <Link
                className="quick-actions-link"
                to={`/entity/${id}/officers`}
              >
                <div className="icon-container">
                  <span className="pi pi-briefcase"></span>
                </div>
                <p className="card-name">Officer Registry</p>
              </Link>
            </div>
            <div className="action-card">
              <Link
                className="quick-actions-link"
                to={`/entity/${id}/powers-of-attorney`}
              >
                <div className="icon-container">
                  <span className="pi pi-shield"></span>
                </div>
                <p className="card-name">Power of Attorney Registry</p>
              </Link>
            </div>
          </>
        )}
        {isUpdateActiveServiceFeatureEnabled && (
          <AdminOnly>
            <div className="action-card">
              <Link
                className="quick-actions-link"
                to={`/entity/${id}/entity-settings/active-services`}
              >
                <div className="icon-container">
                  <span className="pi pi-cog"></span>
                </div>
                <p className="card-name">Entity Settings</p>
              </Link>
            </div>
          </AdminOnly>
        )}
      </div>
    </div>
  );
};

QuickActions.propTypes = {
  hasEntityPlusAccess: PropTypes.bool,
  hasPayrollAccess: PropTypes.bool,
};

export default QuickActions;
